/*
Author: Atul Vasudevan
Story: ENT-2317
 */
import {Component, EventEmitter, Input, Output} from '@angular/core';
import {AlertBannerService, AlertType} from "../../../../lib/alert-banner";
import {WarningModalContentComponent} from "../../../../lib/warning-modal/warning-modal.component";
import {BsModalService} from "ngx-bootstrap/modal";
import {RequestService} from "../../../../services/request/request.service";
import { ConstantsService } from 'src/app/services/constants/constants.service';

@Component({
  selector: 'app-single-recipient',
  templateUrl: './single-recipient.component.pug',
  styleUrls: ['./single-recipient.component.scss'],
  standalone: false
})
export class SingleRecipientComponent {

  @Input() recipient: any;
  @Input() typeOfCheck = 'references';
  @Output() editEmitter = new EventEmitter();
  @Output() editStartedEmitter = new EventEmitter();
  @Output() editEndedEmitter = new EventEmitter();
  @Output() deleteEmitter = new EventEmitter();
  @Output() resetDraftContent = new EventEmitter();
  private bsModalRef: any;
  dataToEdit = {};
  id = -1;
  loading = false;
  isWorkEmailValid = false;

  constructor(private modalService: BsModalService,
              private requestService: RequestService,
              private alertList: AlertBannerService) {
  }

  editRecipient(recipient) {
    this.id = recipient['id'];
    if(this.typeOfCheck == ConstantsService.EXIT_CHECK){
    this.dataToEdit = {
      "draftUid": localStorage.getItem('draft_uid'),
      "recipient": recipient
    }
   } else{
    this.dataToEdit = {
      "draftUid": localStorage.getItem('draft_pulse_uid'),
      "recipient": recipient
    }
   }
    this.editStartedEmitter.emit();
  }

  editRecipientDetails(recipientToEdit) {
    if(this.typeOfCheck == ConstantsService.EXIT_CHECK) {
      this.loading = true;
      this.requestService.editExit(recipientToEdit['recipient'], localStorage.getItem('draft_uid')).subscribe((data: any) => {
        this.editEmitter.emit(data)
          this.loading = false;
        },
        (err: any) => {
          console.log(err);
          this.loading = false;
          this.alertList.append([{
            type: AlertType.DANGER,
            message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
            keepOnRouteChange: true
          }]);
        });
    } else{
      this.loading = true;
      this.requestService.editPulse(recipientToEdit['recipient'], localStorage.getItem('draft_pulse_uid')).subscribe((data: any) => {
        this.editEmitter.emit(data)
        this.loading = false;
      },
      (err: any) => {
        console.log(err);
        this.loading = false;
        this.resetDraftContent.emit('reset')
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! The recipient details you have entered contain errors and have not been saved.`,
          keepOnRouteChange: true
        }]);
      });
    }
  }

  deleteRecipient(event) {
    let initialState = {
      "title": $localize`Remove recipient`,
      "message": $localize`Do you want to continue?`
    };
    this.bsModalRef = this.modalService.show(WarningModalContentComponent, {
      class: 'modal-dialog-centered', initialState
    });
    this.bsModalRef.content.selection.subscribe(res => {
      if (res === true) {
        this.loading = true;
        if(this.typeOfCheck == ConstantsService.EXIT_CHECK) {
          this.requestService.removeExit(localStorage.getItem('draft_uid'), event['id']).subscribe((data: any) => {
              this.deleteEmitter.emit(data);
              this.loading = false;
            },
            (err: any) => {
              console.log(err);
              this.loading = false;
              this.alertList.append([{
                type: AlertType.DANGER,
                message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
                keepOnRouteChange: true
              }]);
            });
          } else {
            this.requestService.removePulse(localStorage.getItem('draft_pulse_uid'), event['id']).subscribe((data: any) => {
              this.deleteEmitter.emit(data)
              this.loading = false;
            },
            (err: any) => {
              console.log(err);
              this.loading = false;
              this.alertList.append([{
                type: AlertType.DANGER,
                message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
                keepOnRouteChange: true
              }]);
            })
          }
      }
    })
  }

  checkClass(recipient, fields) {
    const mailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,3}$/
    this.isWorkEmailValid = mailRegex.test(recipient['work_email'])
    for (let field of fields) {
      if (recipient.meta.error_fields.indexOf(field) != -1) {
        return 'error-recipients';
      } else if (recipient.meta.warning_fields.indexOf(field) != -1) {
        return 'warning';
      }
    }
    if(!recipient.valid_mobile && fields.includes('mobile')){
      return 'error-recipients'
    }
    return ''
  }

  avatarInitials(person: { first_name?: string | null; last_name?: string | null } | null): string {
    const first = (person?.first_name || '').charAt(0);
    const last = (person?.last_name || '').charAt(0);
    return `${first}${last}`;
  }

  recipientDisplayName(person: { first_name?: string | null; last_name?: string | null } | null): string {
    return [person?.first_name, person?.last_name].filter(Boolean).join(' ');
  }

  closeEvent() {
    this.id = -1;
    this.editEndedEmitter.emit();
  }

  checkDate(recipient) {
    if (recipient.end_date_month === "" && recipient.end_date_year !== "") {
      recipient['date'] = recipient.end_date_year;
      return 'error-recipients';
    }
    if (recipient.end_date_year === "" && recipient.end_date_month !== "") {
      recipient['date'] = recipient.end_date_month;
      return 'error-recipients';
    }
    if (recipient.end_date_year === "" && recipient.end_date_month === "") {
      recipient['date'] = "";
      return 'error-recipients';
    }
    recipient['date'] = recipient.end_date_month + ', ' + recipient.end_date_year
    if (isNaN(recipient['end_date_year'])) {
      return 'error-recipients';
    }
    return 'none';
  }

}
